import request, { PagerQueryData, PagerResponseData, ResponseData } from '@/libs/request/request'

export type DemoRole = {
  id: number
  name?:string
}

export default class Service {
  // 获取列表
  static fetchList (query?:any):Promise<ResponseData<DemoRole[]>> {
    return request<ResponseData<DemoRole[]>>({
      method: 'post',
      data: query,
      url: '/fake/demoRole/list'
    })
  }

  // 获取分页列表
  static fetchPageList (query?:PagerQueryData):Promise<PagerResponseData<DemoRole>> {
    return request<PagerResponseData<DemoRole>>({
      method: 'post',
      data: query,
      url: '/fake/DemoRole/listpages'
    })
  }

  // 获取一个实体
  static getOne (id:number):Promise<ResponseData<DemoRole>> {
    return request<ResponseData<DemoRole>>({
      method: 'get',
      url: `/fake/DemoRole/${id}`
    })
  }

  // 新增一个实体
  static createOne (item:DemoRole):Promise<ResponseData<DemoRole>> {
    return request<ResponseData<DemoRole>>({
      method: 'post',
      data: item,
      url: '/fake/DemoRole'
    })
  }

  // 更新一个实体
  static updateOne (item:DemoRole):Promise<ResponseData<DemoRole>> {
    return request<ResponseData<DemoRole>>({
      method: 'put',
      data: item,
      url: '/fake/DemoRole'
    })
  }

  // 删除一个实体
  static deleteOne (id:number):Promise<ResponseData<Boolean>> {
    return request<ResponseData<Boolean>>({
      method: 'delete',
      url: `/fake/DemoRole/${id}`
    })
  }
}
